<template>
  <div>
    <div
      class="side-background login-bg-wrap"
      style="
        background-image: url('/static/img/Training_Academy_Banner_login.png');
      "
    >
      <div class="side-background-foreground">
        <v-card class="mx-auto">
          <v-card-title>
            <img
              src="../assets/img/logo-transparent.png"
              width="250px"
              style="margin: 0 auto"
            />
          </v-card-title>
          <v-card-text>
            <!-- Email Field -->
            <v-text-field
              hide-details="auto"
              class="datainput justify-content-end align-self-center pb-1"
              dense
              outlined
              :label="$t('email')"
              v-model="credentials.mail"
              @keypress.enter="login()"
            ></v-text-field>
            <br />
            <!-- Password Field -->
            <v-text-field
              hide-details="auto"
              class="datainput justify-content-end align-self-center pb-1"
              dense
              outlined
              :label="$t('password')"
              :type="showPassword ? 'text' : 'password'"
              v-model="credentials.password"
              @keypress.enter="login()"
              :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
              @click:append="togglePasswordVisibility"
            ></v-text-field>
            <a
              class="password-reset-link"
              href="/forgot-password"
              style="margin-bottom: 5px"
              >{{ $t("forgot_password") }}</a
            >
            <a
              class="password-reset-link"
              target="_blank"
              :href="`/files/images/KB_DS-Hinweise_Customer_Training_Portal_${$locale}.pdf`"
              style="margin-bottom: 18px"
              >{{ $t("read_privacy_policy") }}</a
            >

            <v-btn
              @click="login()"
              outlined
              depressed
              tile
              class="savebutton mr-2 mb-2"
              >{{ $t("login") }}</v-btn
            >
            <p
              style="
                margin-bottom: unset;
                margin-top: 10px;
                text-align: left;
                color: rgb(58 58 58);
              "
            >
              {{ $t("mail_account") }}
              <a
                class="password-reset-link"
                target=""
                style="width: unset; display: unset; text-decoration: underline"
                :href="`mailto:TrainingAcademy@knorr-bremse.com`"
                >trainingacademy@knorr-bremse.com</a
              >
              {{ $t("mail_assistance") }}
            </p>
          </v-card-text>
          <!-- <a @click="ssoLogin()">SSO Login</a> -->
        </v-card>
      </div>
    </div>
  </div>
</template>

<script>
import { msalInstance, authService } from "../../src/authService.js"; // Adjust the path as per your project structure

export default {
  props: {
    routingTarget: String,
  },

  data() {
    return {
      showPassword: false,

      credentials: {
        mail: "",
        password: "",
      },
    };
  },

  mounted() {
    this.$axios.checkBearer().then(this.onLoggedIn).catch(this.discardError);
  },

  methods: {
    ssoLogin() {
      // Ensure the user is logged in before attempting token acquisition
      if (!authService.getAccount()) {
        // Example: Redirect the user to login
        if (!sessionStorage.getItem("interaction_in_progress")) {
          sessionStorage.setItem("interaction_in_progress", "true");
          authService.login(window.location.href);
        }
        authService.login(window.location.href);
      } else {
        // Example: Fetch access token if user is logged in
        fetchAccessToken();
      }
    },
    async fetchAccessToken() {
      try {
        const accessToken = await authService.acquireToken();
        console.log("Access token:", accessToken);
        // Proceed with API calls or other actions requiring the access token
      } catch (error) {
        console.error("Failed to acquire token:", error);
        // Handle error appropriately
      }
    },
    togglePasswordVisibility() {
      this.showPassword = !this.showPassword;
    },
    login() {
      localStorage.removeItem("elapsedTime2");
      this.$axios.credentials = this.credentials;
      this.$axios.authorize().then(this.onLoggedIn).catch(this.onLoginFailed);
    },
    onLoggedIn(response) {
      this.$axios
        .get("/api/user/me")
        .then(this.onSuccessfulLogin)
        .catch(this.onLoginFailed);
    },
    onSuccessfulLogin(response) {
        if (typeof window.clarity !== "undefined") {
          const encodedUserId = btoa(this.credentials.mail);
          window.clarity("identify", encodedUserId);   // for future sessions
          window.clarity("set", "user_id", encodedUserId); // for custom property tagging now
          if (response.external) {
            window.clarity("event", "Login External");
          } else {
            window.clarity("event", "Login Internal");
          }
        }
      this.$router.push("categories");
      window.location.reload();
    },
    onLoginFailed(error) {
      this.$noty.error(this.$t("ERROR_INVALID_CREDENTIALS"));
      showLoadingCircle(false);
    },
    logError(error) {
      console.log(error);
    },
    discardError(error) {},
  },
};
</script>

<style></style>
